var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',{staticClass:"q-ma-none text-bold price"},[_vm._v("$"+_vm._s(_vm.data.transport.totalPrice))]),(_vm.data.transport.fullPay)?_c('p',{staticClass:"q-ma-none text-red text-bold text-uppercase"},[_vm._v(" Full pay ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }